import {
  BULK_IMPORT_BIDS,
  BULK_IMPORT_DELETE_SELECTED_BIDS,
  BULK_IMPORT_DELETE_BID,
  BULK_IMPORT_LOAD_BIDS,
  BULK_IMPORT_EDIT_SELECTED_BIDS,
  BULK_IMPORT_BIDS_SELECTED_KEYWORDS,
  BULK_IMPORT_RESET,
  RESET,
} from '../../types';

import { convertArrayOfObjectToHashTable } from '@/utils/arrayToHashTable';
import hashTableToArray from '@/utils/hashTableToArray';

export const state = () => ({
  bids: [],
  selectedKeywords: [],
});

export const getters = {
  [BULK_IMPORT_BIDS]({ bids }) {
    return bids;
  },
  [BULK_IMPORT_BIDS_SELECTED_KEYWORDS]({ selectedKeywords }) {
    return selectedKeywords;
  },
};

/* eslint-disable no-param-reassign */
export const mutations = {
  [BULK_IMPORT_LOAD_BIDS](stateObj, bids) {
    stateObj.bids = bids;
  },
  [BULK_IMPORT_BIDS_SELECTED_KEYWORDS](stateObj, selectedKeywords) {
    stateObj.selectedKeywords = selectedKeywords;
  },
  [BULK_IMPORT_DELETE_SELECTED_BIDS](stateObj) {
    const bidsHashMap = convertArrayOfObjectToHashTable(
      stateObj.bids,
      ({ keyword }) => keyword,
    );

    stateObj.selectedKeywords.forEach(({ keyword }) => {
      delete bidsHashMap[keyword];
    });

    stateObj.bids = hashTableToArray(bidsHashMap);
  },
  [BULK_IMPORT_DELETE_BID](stateObj, bid) {
    stateObj.bids = stateObj.bids.filter(
      ({ keyword }) => keyword !== bid.keyword,
    );
  },
  [BULK_IMPORT_EDIT_SELECTED_BIDS](stateObj, bidInfo) {
    const keywordsHashTable = convertArrayOfObjectToHashTable(
      stateObj.selectedKeywords,
      ({ keyword }) => keyword,
    );

    stateObj.bids = stateObj.bids.map(item => {
      if (item.keyword in keywordsHashTable) {
        return {
          ...item,
          ...bidInfo,
        };
      }
      return item;
    });
  },
  [BULK_IMPORT_RESET](stateObj) {
    Object.assign(stateObj, state());
  },
  [RESET](stateObj) {
    Object.assign(stateObj, state());
  },
};

export const actions = {
  [BULK_IMPORT_LOAD_BIDS]({ commit }, bids) {
    commit(BULK_IMPORT_LOAD_BIDS, bids);
  },
  [BULK_IMPORT_EDIT_SELECTED_BIDS]({ commit }, bidInfo) {
    commit(BULK_IMPORT_EDIT_SELECTED_BIDS, bidInfo);
  },
  [BULK_IMPORT_DELETE_SELECTED_BIDS]({ commit }) {
    commit(BULK_IMPORT_DELETE_SELECTED_BIDS);
  },
  [BULK_IMPORT_BIDS_SELECTED_KEYWORDS]({ commit }, selectedKeywords) {
    commit(BULK_IMPORT_BIDS_SELECTED_KEYWORDS, selectedKeywords);
  },
  [BULK_IMPORT_DELETE_BID]({ commit }, bid) {
    commit(BULK_IMPORT_DELETE_BID, bid);
  },
  [BULK_IMPORT_RESET]({ commit }) {
    commit(BULK_IMPORT_RESET);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
